import About from "./About";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Partnerships from "./Partnerships";
import Rewards from "./Rewards";

import "./Home.scss";

import archie from "../assets/archie.svg";
import pfpFlipped from "../assets/pfp-flipped.svg";

const Home = () => {
  return (
    <>
      <Navbar />
      <div className="home-section">
        <div className="">
          <div id="titleSectionHome" className="my-6">
            <div className="home-title" id="title">
              Building a communi
              <span className="t">T</span>
              <span className="y">Y</span> one reply at a time
            </div>
          </div>

          <div id="subtitleSectionHome" className="my-6">
            <div className="subtitle">
              Generative art project of 6969 NFTs with a focus on the holders.
              We aim to reward those that truly help build the community.
            </div>
          </div>
        </div>

        <div id="imageSectionHome">
          <div id="archieHomeSection">
            <img src={archie} className="archie-image" alt="reply guy" />
          </div>

          <div id="buttonContainerHome">
            <button className="button is-primary reply-guys-button">
              Minting Q3 2023
            </button>
          </div>

          <div className="flipped-image-container">
            <img src={pfpFlipped} alt="reply guy" />
          </div>
        </div>
      </div>
      <About />
      <Rewards />
      <Partnerships />
      <Footer />
    </>
  );
};

export default Home;
